<template>
  <div class="divBox">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <div class="container">
          <el-form size="small" inline label-width="100px">
            <el-form-item label="回收类型：">
              <el-radio-group
                v-model="tableFrom.product_deposit"
                type="button"
                @change="getList(1)"
              >
                <el-radio-button label=""
                  >全部
                  {{ "(" + orderChartType.all ? orderChartType.all : 0 + ")" }}
                </el-radio-button>
                <el-radio-button label="2"
                  >已寄存
                  {{
                    "(" + orderChartType.deposit_num
                      ? orderChartType.deposit_num
                      : 0 + ")"
                  }}
                </el-radio-button>
                <el-radio-button label="1"
                  >普通回收
                  {{
                    "(" + orderChartType.ordinary_num
                      ? orderChartType.ordinary_num
                      : 0 + ")"
                  }}
                </el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="订单状态：">
              <el-radio-group
                v-model="tableFrom.status"
                type="button"
                @change="getList(1)"
              >
                <el-radio-button label=""
                  >全部
                  {{ "(" + orderChartType.all ? orderChartType.all : 0 + ")" }}
                </el-radio-button>
                <el-radio-button label="0"
                  >已提交
                  {{
                    "(" + orderChartType.submit
                      ? orderChartType.submit
                      : 0 + ")"
                  }}
                </el-radio-button>
                <el-radio-button label="1"
                  >已入库
                  {{
                    "(" + orderChartType.complete
                      ? orderChartType.complete
                      : 0 + ")"
                  }}
                </el-radio-button>
                <el-radio-button label="2"
                  >回收成功
                  {{
                    "(" + orderChartType.success
                      ? orderChartType.success
                      : 0 + ")"
                  }}
                </el-radio-button>
                <el-radio-button label="-2"
                  >回收失败
                  {{
                    "(" + orderChartType.fail ? orderChartType.fail : 0 + ")"
                  }}
                </el-radio-button>
                <el-radio-button label="-1"
                  >已取消
                  {{
                    "(" + orderChartType.cancel
                      ? orderChartType.cancel
                      : 0 + ")"
                  }}
                </el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="商品状态：">
              <el-radio-group
                v-model="tableFrom.is_worn"
                type="button"
                @change="getList(1)"
              >
                <el-radio-button label=""
                  >全部
                  {{ "(" + orderChartType.all ? orderChartType.all : 0 + ")" }}
                </el-radio-button>
                <el-radio-button label="0"
                  >未破损
                  {{
                    "(" + orderChartType.noWorn
                      ? orderChartType.noWorn
                      : 0 + ")"
                  }}
                </el-radio-button>
                <el-radio-button label="1"
                  >破损
                  {{
                    "(" + orderChartType.yesWorn
                      ? orderChartType.yesWorn
                      : 0 + ")"
                  }}
                </el-radio-button>
                <el-radio-button label="2"
                  >申请退回
                  {{
                    "(" + orderChartType.applyWorn
                      ? orderChartType.applyWorn
                      : 0 + ")"
                  }}
                </el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="时间选择：" class="width100">
              <el-radio-group
                v-model="tableFrom.date"
                type="button"
                class="mr20"
                size="small"
                @change="selectChange(tableFrom.date)"
              >
                <el-radio-button
                  v-for="(item, i) in fromList.fromTxt"
                  :key="i"
                  :label="item.val"
                  >{{ item.text }}
                </el-radio-button>
              </el-radio-group>
              <el-date-picker
                v-model="timeVal"
                value-format="yyyy/MM/dd"
                format="yyyy/MM/dd"
                size="small"
                type="daterange"
                placement="bottom-end"
                placeholder="自定义时间"
                style="width: 250px"
                @change="onchangeTime"
              />
            </el-form-item>
            <el-form-item label="入库时间：" class="width150">
              <el-date-picker
                v-model="warehousTimeVal"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                size="small"
                type="datetimerange"
                placement="bottom-end"
                placeholder="自定义时间"
                style="width: 250px"
                @change="onchangeWarehousTime"
              />
            </el-form-item>
            <el-form-item label="分类名称：" style="display: inline-block">
              <el-cascader
                v-model="tableFrom.category_id"
                class="selWidth"
                :options="recoveryCateList"
                :props="props"
                clearable
                @change="getList(1)"
              />
            </el-form-item>
            <el-form-item label="寄件类型：" style="display: inline-block">
              <el-select
                v-model="tableFrom.express_type"
                clearable
                placeholder="请选择"
                class="selWidth"
                @change="getList(1)"
              >
                <el-option label="自行寄件" value="1" />
                <el-option label="预约上门寄件" value="2" />
              </el-select>
            </el-form-item>
            <el-form-item
              label="物流单号："
              class="width100"
              style="display: inline-block"
            >
              <el-input
                v-model="tableFrom.express_num"
                @keyup.enter.native="getList(1)"
                placeholder="请输入物流单号"
                class="selWidth"
                size="small"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  size="small"
                  class="el-button-solt"
                  @click="getList(1)"
                />
              </el-input>
            </el-form-item>
            <el-form-item
              label="关键字："
              class="width100"
              style="display: inline-block"
            >
              <el-input
                v-model="tableFrom.keywords"
                @keyup.enter.native="getList(1)"
                placeholder="请输入订单号/sku/收货人/联系方式"
                class="selWidth"
                size="small"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  size="small"
                  class="el-button-solt"
                  @click="getList(1)"
                />
              </el-input>
            </el-form-item>
            <el-form-item
              label="用户信息："
              class="width100"
              style="display: inline-block"
            >
              <el-input
                v-model="tableFrom.username"
                @keyup.enter.native="getList(1)"
                placeholder="请输入用户昵称/手机号"
                class="selWidth"
                size="small"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  size="small"
                  class="el-button-solt"
                  @click="getList(1)"
                />
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <cards-data :card-lists="cardLists" />
        <div class="mb15">
          <el-button size="mini" class="mr10" @click="openVisibleMoney"
            >分配余额</el-button
          >
        </div>
      </div>
      <el-table
        v-loading="listLoading"
        :data="tableData.data"
        style="width: 100%"
        height="500"
        size="small"
      >
        <el-table-column label="ID" prop="recovery_order_id" min-width="60" />
        <el-table-column label="订单号" prop="order_sn" min-width="160" />
        <el-table-column
          label="物流单号"
          prop="express_list.0.express_num"
          min-width="160"
        />
        <el-table-column
          label="用户昵称"
          prop="user.nickname"
          min-width="100"
        />
        <el-table-column label="品类" min-width="200">
          <template slot-scope="scope">
            <!--            -->
            <el-tooltip
              :content="scope.row.category_name"
              placement="bottom"
              effect="light"
            >
              <div
                style="
                  height: 24px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  width: 160px;
                "
              >
                {{ scope.row.category_name }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          label="预计金额"
          prop="recovery_price"
          min-width="100"
        />
        <el-table-column label="入库数量" prop="recovery_num" min-width="80" />
        <!-- <el-table-column label="联系人" prop="express_phone" min-width="100" /> -->
        <!--        <el-table-column-->
        <!--          label="回收类型"-->
        <!--          prop="status_text"-->
        <!--          min-width="80" />-->
        <el-table-column label="回收类型" min-width="100">
          <template slot-scope="scope">
            <span>{{
              scope.row.product_deposit == 2 ? "寄存中" : "普通回收"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="status_text" min-width="160" />
        <el-table-column label="商品状态" min-width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.is_worn == 1 ? "破损" : "未破损" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否申请退回" min-width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.apply_return == 1 ? "是" : "否" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="入库时间" min-width="140">
          <template slot-scope="scope">
            {{ scope.row.warehous_date ? scope.row.warehous_date : "-" }}
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="create_time" min-width="140">
          <template slot-scope="scope">
            {{ scope.row.create_time ? scope.row.create_time : "-" }}
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="180" fixed="right">
          <template slot-scope="scope">
            <div style="display: flex; flex-wrap: wrap">
              <el-button
                type="text"
                size="small"
                v-if="
                  scope.row.status == 0 ||
                  scope.row.status == 1 ||
                  scope.row.status == 2
                "
                @click="orderFn(scope.row)"
                >分配订单
              </el-button>
              <!-- 详情 -->
              <el-button
                type="text"
                size="small"
                @click="onDetail(scope.row.recovery_order_id)"
                >详情</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          :page-sizes="[20, 40, 60, 80]"
          :page-size="tableFrom.limit"
          :current-page="tableFrom.page"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableData.total"
          @size-change="handleSizeChange"
          @current-change="pageChange"
        />
      </div>
    </el-card>
    <el-dialog title="分配余额" :visible.sync="visibleMoney" width="500px">
      <el-card>
        <el-row>
          <el-col :span="24">
            <div style="font-size: 24px; margin-bottom: 30px">
              余额：{{ nowUser.now_money }}
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <el-input
              v-model="allocation"
              @keyup.enter.native="getUserList"
              placeholder="请输入搜索账号"
              class="selWidth"
              size="small"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                size="small"
                class="el-button-solt"
                @click="getUserList"
              />
            </el-input>
          </el-col>
        </el-row>
        <el-row v-if="pointUser.phone">
          <el-col :span="24">
            <div style="margin-top: 30px">
              手机号：{{ pointUser.phone }}，昵称：{{
                pointUser.nickname
              }},用户余额：{{ pointUser.now_money }}
            </div>
          </el-col>
          <el-col :span="4">
            <div style="margin-top: 30px">
              <div>
                <el-input
                  type="number"
                  v-model="allocation_money"
                  placeholder="请输入分配金额"
                  class="selWidth"
                  size="small"
                  min="0"
                >
                </el-input>
              </div>
              <div style="margin-top: 10px; margin-bottom: 20px">
                <el-input
                  v-model="allocation_remark"
                  placeholder="请输入备注"
                  class="selWidth"
                  size="small"
                />
              </div>
              <el-popconfirm
                slot="append"
                hide-icon
                placement="top"
                :title="'确定分配给' + pointUser.phone + '吗？'"
                @confirm="doAllocation"
              >
                <el-button
                  slot="reference"
                  type="primary"
                  size="small"
                  class="el-button-solt"
                  ><span style="color: white">确认</span></el-button
                >
              </el-popconfirm>
            </div>
          </el-col>
        </el-row>
      </el-card>
    </el-dialog>

    <el-dialog title="分配订单" :visible.sync="visibleOrder" width="500px">
      <el-card>
        <el-row>
          <el-col :span="4">
            <el-input
              v-model="allocation"
              @keyup.enter.native="getUserList"
              placeholder="请输入搜索账号"
              class="selWidth"
              size="small"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                size="small"
                class="el-button-solt"
                @click="getUserList"
              />
            </el-input>
          </el-col>
        </el-row>
        <el-row v-if="pointUser.phone">
          <el-col :span="24">
            <div style="margin-top: 30px">
              手机号：{{ pointUser.phone }}，昵称：{{ pointUser.nickname }}
              <el-popconfirm
                slot="append"
                hide-icon
                placement="top"
                :title="'确定分配订单给' + pointUser.phone + '吗？'"
                @confirm="doAllocationOrder"
              >
                <el-button slot="reference" type="primary" size="small"
                  ><span style="color: white">确认</span></el-button
                >
              </el-popconfirm>
            </div>
          </el-col>
        </el-row>
      </el-card>
    </el-dialog>

    <!-- 详情 -->
    <el-dialog
      v-if="dialogVisible"
      title="详情"
      :visible.sync="dialogVisible"
      width="1300px"
      top="0"
    >
      <div v-loading="loading" class="divBox boxDetial">
        <el-card class="box-card">
          <el-form ref="formData" label-width="130px" class="demo-ruleForm">
            <el-row :gutter="24">
              <el-col :span="4">
                <el-form-item label-width="80px" label="订单ID：">
                  <div>{{ formData.recovery_order_id }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label-width="100px" label="用户手机号：">
                  <div>{{ formData.user.phone }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label-width="100px" label="订单号：">
                  <div>{{ formData.order_sn }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label-width="80px" label="状态：">
                  <div>{{ formData.status_text }}</div>
                </el-form-item>
              </el-col>
              <!-- 报单信息 -->
              <div class="decla_row">
                <div class="decla_title">报单信息</div>
                <div
                  v-for="(item, index) in formData.product_list"
                  :key="index"
                  style="display: inline-block"
                >
                  <el-col :span="24">
                    <el-form-item
                      :label="(item.cate_name ? item.cate_name : '其他') + '：'"
                    ></el-form-item>
                  </el-col>
                  <div v-for="(it, inf) in item.sku_list" :key="index">
                    <el-col :span="24">
                      <el-form-item label="">
                        <span>sku : {{ it.sku }}</span> &nbsp;&nbsp;&nbsp;&nbsp;
                        <span>数量 : {{ it.num }}</span>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <span>价格 : {{ it.price }}</span>
                        <div v-if="it.is_worn == 1" style="color: red">
                          状态 : {{ it.is_worn == 1 ? "破损" : "未破损" }}
                        </div>
                        <div v-if="it.is_worn == 1">
                          入库备注 : {{ it.remark }}
                        </div>
                        <div
                          v-if="it.is_worn == 1"
                          v-for="(im, imind) in it.image"
                          :key="index"
                          style="display: inline-block"
                        >
                          <el-image
                            style="width: 80px; height: 80px"
                            :src="im || ''"
                            :preview-src-list="[im ? im : '']"
                          />
                        </div>
                        <!--                        <div v-if="formData.status == 2">结算备注 : {{ it.sett_remark }}</div>-->
                      </el-form-item>
                    </el-col>
                  </div>
                </div>
                <div style="display: flex; flex-direction: column">
                  <div style="display: inline-block">
                    <el-col>
                      <el-form-item label="报单总数量：">
                        <div class="blodClass">{{ recoveryNum(formData) }}</div>
                      </el-form-item>
                    </el-col>
                  </div>
                  <div style="display: inline-block">
                    <el-col>
                      <el-form-item label="报单预估金额：">
                        <div>{{ recovery_price }}</div>
                      </el-form-item>
                    </el-col>
                  </div>
                  <div style="display: inline-block">
                    <el-col :span="12">
                      <el-form-item label="联系人：">
                        <div>{{ formData.express_phone }}</div>
                      </el-form-item>
                    </el-col>
                  </div>
                  <div style="display: inline-block">
                    <el-col :span="24">
                      <el-form-item label="补充图片：">
                        <div
                          v-for="(item, index) in formData.express_image"
                          :key="index"
                          style="display: inline-block; margin: 0 10px 10px 0"
                        >
                          <el-image
                            style="width: 80px; height: 80px"
                            :src="item || ''"
                            :preview-src-list="[item ? item : '']"
                          />
                        </div>
                      </el-form-item>
                    </el-col>
                  </div>
                  <div style="display: inline-block">
                    <el-col :span="24">
                      <el-form-item label="平台地址：">
                        <div>{{ formData.platform_address }}</div>
                      </el-form-item>
                    </el-col>
                  </div>
                  <div class="display: inline-block">
                    <el-col :span="12">
                      <el-form-item label="平台收件人：">
                        <div>{{ formData.platform_name }}</div>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="平台联系电话：">
                        <div>{{ formData.platform_phone }}</div>
                      </el-form-item>
                    </el-col>
                  </div>

                  <div style="display: inline-block">
                    <el-col :span="24">
                      <el-form-item label="用户地址：">
                        <div>{{ formData.user_address }}</div>
                      </el-form-item>
                    </el-col>
                  </div>
                  <div style="display: inline-block">
                    <el-col :span="12">
                      <el-form-item label="用户收件人：">
                        <div>{{ formData.user_name }}</div>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="用户联系电话：">
                        <div>{{ formData.user_phone }}</div>
                      </el-form-item>
                    </el-col>
                  </div>
                  <div style="display: inline-block">
                    <el-col :span="24">
                      <el-form-item label="寄件类型：">
                        <span>{{
                          formData.express_type == 1 ? "自行寄件" : "预约上门"
                        }}</span>
                      </el-form-item>
                    </el-col>
                  </div>
                  <el-col :span="24">
                    <el-form-item
                      label="寄件地址："
                      v-if="formData.express_type == 2"
                    >
                      <span>{{ formData.order_express.express_address }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      label="寄件人："
                      v-if="formData.express_type == 2"
                    >
                      <span>{{ formData.order_express.express_name }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      label="寄件电话："
                      v-if="formData.express_type == 2"
                    >
                      <span>{{ formData.order_express.express_phone }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item
                      label="商品重量："
                      v-if="formData.express_type == 2"
                    >
                      <span>{{ formData.order_express.express_weight }}KG</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      label="物流创建时间："
                      v-if="formData.express_type == 2"
                    >
                      <span>{{ formData.order_express.create_time }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      label="取件时间："
                      v-if="formData.express_type == 2"
                    >
                      <span
                        >{{ formData.order_express.express_day_type }}
                        {{ formData.order_express.express_pickup_start }}-{{
                          formData.order_express.express_pickup_end
                        }}</span
                      >
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item
                      label="物流公司："
                      v-if="formData.express_type == 2"
                    >
                      <span
                        >{{ formData.order_express.product_express_company }}
                        {{ formData.order_express.express_num }}</span
                      >
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item
                      label="邮费："
                      v-if="formData.express_type == 2"
                    >
                      <span>{{ formData.order_express.express_price }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      label="物流状态："
                      v-if="formData.express_type == 2"
                    >
                      <span>{{
                        formData.order_express.express_status == 0
                          ? "提交订单，待取件"
                          : formData.order_express.express_status == 1
                          ? "已取件"
                          : formData.order_express.express_status == 2
                          ? "已支付"
                          : "已取消"
                      }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      label="物流支付状态："
                      v-if="formData.express_type == 2"
                    >
                      <span>{{
                        formData.order_express.express_pay == 1
                          ? "已支付"
                          : "未支付"
                      }}</span>
                    </el-form-item>
                  </el-col>

                  <el-col :span="12">
                    <el-form-item label="创建时间：">
                      <div>{{ formData.create_time }}</div>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      label="完成时间："
                      v-if="
                        formData.status == 1 ||
                        formData.status == -2 ||
                        formData.status == -1
                      "
                    >
                      <div>{{ formData.recovery_time }}</div>
                    </el-form-item>
                  </el-col>
                </div>
              </div>
              <!--              <el-col :span="12">-->
              <!--                <el-form-item label="物流单号：">-->
              <!--                  <div>{{formData.express_num}}</div>-->
              <!--                </el-form-item>-->
              <!--              </el-col>-->
              <!--              <el-col :span="12">-->
              <!--                <el-form-item label="物流公司：">-->
              <!--                  <div>{{formData.express_company}}</div>-->
              <!--                </el-form-item>-->
              <!--              </el-col>-->
              <!-- 物流信息 -->
              <div
                style="
                  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
                  margin-top: 20px;
                  padding: 20px 0;
                  width: 100%;
                "
              >
                <div
                  v-for="(item, index) in formData.express_list"
                  :key="index"
                  style="display: inline-block"
                >
                  <el-col :span="24">
                    <el-form-item :label="'物流信息' + (index + 1) + '：'">
                      单号：{{ item.express_num }} - {{ item.express_company }}
                      {{
                        item.express_status == 1
                          ? "已入库"
                          : item.express_status == 2
                          ? "已结算"
                          : "未入库"
                      }}
                      - 入库时间 : {{ item.express_time }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="">
                      <div class="blodClass" v-if="item.express_status >= 1">
                        入库备注 : {{ item.express_remark }}
                      </div>
                      <div
                        v-for="(it, ind) in item.express_image"
                        v-if="item.express_status >= 1"
                        :key="index"
                        style="display: inline-block"
                      >
                        <el-image
                          style="width: 120px; height: 120px"
                          :src="it || ''"
                          :preview-src-list="[it ? it : '']"
                        />
                      </div>
                      <div
                        v-for="(vi, vind) in item.express_video"
                        :key="index"
                        v-if="item.express_video"
                        style="display: inline-block"
                      >
                        <video
                          style="width: 120px; height: 120px"
                          :src="vi"
                          controls="controls"
                        >
                          您的浏览器不支持 video 标签。
                        </video>
                      </div>
                      <div
                        v-for="(p, vind) in item.product_list"
                        :key="vind"
                        v-if="item.express_status >= 1"
                        style="display: inline-block; width: 100%"
                      >
                        <span style="font-weight: bold"
                          >商品名 :
                          {{ p.cate_name ? p.cate_name : "其他" }}</span
                        >
                        <table class="sku-tb">
                          <tr style="border: 1px solid black">
                            <th>sku</th>
                            <th>入库数</th>
                            <th>入库批号</th>
                            <th>在库</th>
                            <th>出库</th>
                            <th width="50px">已出库单价</th>
                            <th width="50px">已出库总额</th>
                            <th width="50px">寄存数量</th>
                            <th width="50px">
                              <span class="blodClass">退回数量</span>
                            </th>
                            <th width="50px">
                              <span class="blodClass" style="font-size: 12px"
                                >入库异常总数量</span
                              >
                            </th>
                            <th class="blodClass" width="50px">假货异常数量</th>
                            <th width="50px">
                              <span class="blodClass" style="font-size: 12px"
                                >处理异常数量</span
                              >
                            </th>
                            <th width="80px">
                              <span class="blodClass">异常备注</span>
                            </th>
                            <th width="50px">异常图片</th>
                            <th><span class="blodClass">结算备注</span></th>
                          </tr>
                          <tr v-for="(sku, index) in p.sku_list">
                            <td>
                              <el-tooltip
                                :content="sku.sku"
                                placement="bottom"
                                effect="light"
                              >
                                <div class="sku-name">{{ sku.sku }}</div>
                              </el-tooltip>
                            </td>
                            <td>{{ sku.num }}</td>
                            <td>
                              <div v-for="(item, index) in sku.batch_list">
                                {{ item.batch_number }}
                                <span class="batch_num"
                                  >x{{ item.batch_num }}</span
                                >
                              </div>
                            </td>
                            <td>{{ sku.warehous_count }}</td>
                            <td>{{ sku.outbound_count }}</td>
                            <td>{{ parseInt(sku.outbound_price) }}</td>
                            <td>{{ sku.outbound_price_all }}</td>
                            <td>
                              {{
                                sku.sku_product_deposit_num
                                  ? sku.sku_product_deposit_num
                                  : "-"
                              }}
                            </td>
                            <td class="blodClass">
                              {{
                                sku.sku_product_return_num
                                  ? sku.sku_product_return_num
                                  : "-"
                              }}
                            </td>
                            <td>
                              <span
                                v-if="sku.worn_num"
                                class="blodClass"
                                style=""
                                >{{ sku.worn_num }}</span
                              >
                              <span v-else>无</span>
                            </td>
                            <td class="blodClass">
                              <span
                                v-if="sku.fail_count"
                                class="blodClass"
                                style=""
                                >{{ sku.fail_count }}</span
                              >
                              <span v-else>无</span>
                            </td>
                            <td>
                              <span
                                v-if="sku.worn_return"
                                class="blodClass"
                                style=""
                                >{{ sku.worn_return }}</span
                              >
                              <span v-else>无</span>
                            </td>
                            <td>
                              <template v-if="sku.worn_num">
                                <el-tooltip
                                  :content="sku.remark"
                                  placement="bottom"
                                  effect="light"
                                >
                                  <div class="sku-name blodClass">
                                    {{ sku.remark }}
                                  </div>
                                </el-tooltip>
                              </template>
                              <template v-else>-</template>
                            </td>
                            <td>
                              <div
                                style="
                                  display: flex;
                                  align-items: center;
                                  justify-content: center;
                                "
                                v-if="sku.image.length"
                              >
                                <el-image
                                  style="width: 30px; height: 30px"
                                  :src="skui || ''"
                                  :preview-src-list="[skui ? skui : '']"
                                  v-for="skui in sku.image"
                                />
                              </div>
                              <span v-else>-</span>
                            </td>
                            <td class="blodClass">
                              {{ sku.sett_remark ? sku.sett_remark : "-" }}
                            </td>
                          </tr>
                        </table>
                      </div>
                    </el-form-item>
                  </el-col>
                </div>
              </div>
              <div
                style="width: 100%; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)"
                v-if="formData.order_return_list.length > 0"
              >
                <div style="display: inline-block; width: 100%">
                  <el-col :span="24">
                    <el-form-item label="退回详情：">
                      <!--                      <div v-if="formData.apply_return==1">{{formData.apply_time}}→<span style="color: red">申请退回</span></div>-->
                      <table class="sku-tb">
                        <tr style="border: 1px solid black">
                          <th>sku</th>
                          <th>申请时间</th>
                          <th>退回数量</th>
                          <th>快递单号</th>
                          <th>状态</th>
                        </tr>
                        <tr v-for="(sku, index) in formData.order_return_list">
                          <td>
                            <div class="sku-name">
                              {{ sku.cate_name + sku.sku }}
                            </div>
                          </td>
                          <td>{{ sku.create_time }}</td>
                          <td>{{ sku.num }}</td>
                          <td>
                            {{ sku.express_num }}
                          </td>
                          <td>
                            {{ sku.apply_return == 1 ? "申请退回" : "已退回" }}
                          </td>
                        </tr>
                      </table>
                    </el-form-item>
                  </el-col>
                </div>
              </div>

              <div
                style="width: 100%; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)"
                v-if="formData.apply_return"
              >
                <div style="display: inline-block; width: 100%">
                  <el-col :span="24">
                    <el-form-item label="异常处理：">
                      <div v-if="formData.apply_return == 1">
                        {{ formData.apply_time }}→<span style="color: red"
                          >申请退回</span
                        >
                      </div>
                      <div v-if="formData.apply_return == 2">
                        {{ formData.wore_handle_time }}
                        <span style="margin-left: 20px">物流公司：</span>
                        {{ formData.wore_handle_express_company }}
                        <span style="margin-left: 20px">快递单号：</span
                        >{{ formData.wore_handle_express_num }}
                        <span style="margin-left: 20px"> 物流状态：</span
                        >{{
                          wornStatusFn(
                            formData.order_worn_express.express_platform_status
                          )
                        }}
                        <span style="margin-left: 20px"> 快递员电话：</span
                        >{{ formData.order_worn_express.courierMobile }}
                      </div>

                      <div
                        v-if="formData.apply_return == 1"
                        v-for="(re, ind) in formData.apply_content"
                      >
                        <span style="font-weight: bold"
                          >{{ re.cate_name ? re.cate_name : "其他" }}:</span
                        >
                        <div
                          v-for="(re2, ind2) in re.sku_list"
                          style="padding-left: 50px"
                        >
                          {{ re2.sku }}&nbsp;&nbsp;x&nbsp;<span
                            style="font-size: 16px; color: red"
                            >{{ re2.num }}
                          </span>
                        </div>
                      </div>
                      <div
                        v-if="formData.apply_return == 2"
                        v-for="(re, ind) in formData.worn_handle_content"
                      >
                        <span style="font-weight: bold"
                          >{{ re.cate_name }}:</span
                        >
                        <div
                          v-for="(re2, ind2) in re.sku_list"
                          style="padding-left: 50px"
                        >
                          {{ re2.sku }}&nbsp;<span
                            style="font-size: 16px; color: red"
                            >&nbsp;x&nbsp;{{ re2.num }}</span
                          >
                        </div>
                      </div>
                      <div class="blodClass">
                        异常备注：{{ formData.worn_handle_remark }}
                      </div>
                    </el-form-item>
                  </el-col>
                </div>
              </div>
            </el-row>
          </el-form>
        </el-card>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import { roterPre } from "@/settings";
import { fromList } from "@/libs/constants";
import {
  recoveryCategoryMenuListApi,
  recoveryOrderBatchSettApi,
  recoveryOrderCardListApi,
  recoveryOrderChartListApi,
  recoveryOrderListApi,
  recoverSearchUserApi,
  recoveryOrderDetailApi,
  amountHandleApi,
  orderHandleApi,
} from "@/api/recovery";
import cardsData from "@/components/cards";
import orderWornHandle from "@/views/recovery/order/orderWornHandle.vue";

export default {
  name: "officialOrder",
  components: { orderWornHandle, cardsData },
  computed: {
    recoveryNum() {
      return function (data) {
        let nums = 0;
        data.product_list.map((item, index) => {
          item.sku_list.map((v, i) => {
            nums += v.num;
          });
        });
        return nums;
      };
    },
    // 报单预估金额
    recovery_price() {
      let price = 0;
      this.formData.product_list.map((it, i) => {
        this.formData.product_list[i].sku_list.map((item, index) => {
          price += Number(item.price);
        });
      });
      return price;
    },
  },
  data() {
    return {
      dialogVisible: false, //  详情弹框
      nowOrder: {},
      visibleOrder: false,
      allocation_money: null,
      nowUser: {},
      pointUser: {
        phone: "",
      },
      allocation: "", //分配账号
      visibleMoney: false,
      props: { checkStrictly: true, emitPath: false },
      moren: require("@/assets/images/f.png"),
      colors: ["#99A9BF", "#F7BA2A", "#FF9900"],
      listLoading: true,
      tableData: {
        data: [],
        total: 0,
      },
      roterPre: roterPre,
      tableFrom: {
        page: 1,
        limit: 20,
      },
      orderChartType: {},
      fromList: fromList,
      cardLists: [],
      timeVal: [],
      warehousTimeVal: [],
      loading: false,
      formData: {},
      ruleForm: {},
      appraisal_order_id: "",
      recoveryCateList: [],
      formStatusData: [],
      status: "",
      statusList: [],
      recovery_price_total: 0,
      recovery_num_total: 0,
      chkName: "",
      checkedIds: [], // 订单当前页选中的数据
      noChecked: [], // 订单全选状态下当前页不选中的数据
      checkedPage: [],
      allCheck: false,
      cancel_time: null,
      recoveryOrderIdList: {
        recovery_order_id_list: [],
      },
      recovery_order_id: 0,
      old_flag: 0,
      allocation_remark: "",
    };
  },
  mounted() {
    this.getList(1);
    this.headerList();
    this.checkedIds = [];
  },
  methods: {
    doAllocationOrder() {
      //进行分配订单
      if (!this.pointUser.phone) {
        this.$message.error("没有目标用户");
        return;
      }
      if (this.loading) {
        this.$message.error("请勿频繁操作");
        return;
      }
      this.loading = true;
      orderHandleApi({
        recovery_order_id: this.nowOrder.recovery_order_id,
        uid: this.pointUser.uid,
      })
        .then((res) => {
          this.$message.success(res.message);
          this.getList();
          this.loading = false;
        })
        .catch((res) => {
          this.$message.error(res.message);
          this.loading = false;
        });
      this.pointUser = {
        phone: null,
      };
      this.allocation = null;
      this.visibleOrder = false;
    },
    orderFn(item) {
      //打开分配订单弹框
      this.nowOrder = item;
      this.visibleOrder = true;
    },
    doAllocation() {
      //进行分配余额
      if (!this.pointUser.phone) {
        this.$message.error("没有目标用户");
        return;
      }
      if (parseFloat(this.allocation_money) > 0) {
        if (this.loading) {
          this.$message.error("请勿频繁操作");
          return;
        }
        this.loading = true;

        amountHandleApi({
          allocation_uid: 7598,
          uid: this.pointUser.uid,
          allocation_price: this.allocation_money,
          allocation_remark: this.allocation_remark,
        })
          .then((res) => {
            this.$message.success(res.message);
            this.getCardList();
            this.loading = false;
          })
          .catch((res) => {
            this.$message.error(res.message);
            this.loading = false;
          });
        this.allocation_money = null;
        this.pointUser = {
          phone: null,
        };
        this.allocation = null;
        this.visibleMoney = false;
      } else {
        this.$message.error("请输入正确金额");
      }
    },
    getUserList() {
      //根据账号搜索用户
      if (!this.allocation.trim().length) {
        this.$message.error("搜索内容不能为空");
        return;
      }
      this.pointUser = {
        phone: null,
      };
      recoverSearchUserApi({ phone: this.allocation })
        .then((res) => {
          if (res.data.userList) {
            this.pointUser = res.data.userList;
          } else {
            this.$message.error("搜索不到该账号");
          }
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
    },
    openVisibleMoney() {
      //打开分配余额弹框
      recoverSearchUserApi({ uid: 7598 })
        .then((res) => {
          this.nowUser = res.data.userList;
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
      this.visibleMoney = true;
    },
    onHandle(name) {
      this.chkName = this.chkName === name ? "" : name;
      this.changeType(!(this.chkName === ""));
    },
    changeType(v) {
      if (v) {
        if (!this.chkName) {
          this.chkName = "dan";
        }
      } else {
        this.chkName = "";
        this.allCheck = false;
      }
      const index = this.checkedPage.indexOf(this.tableFrom.page);
      if (this.chkName === "dan") {
        this.checkedPage.push(this.tableFrom.page);
      } else if (index > -1) {
        this.checkedPage.splice(index, 1);
      }

      this.syncCheckedId();
    },
    syncCheckedId() {
      //   const ids = this.tableData.data.map(v => v.uid)
      const ids = this.tableData.data.map((v) => {
        if (!v.cancel_time) {
          return v.recovery_order_id;
        }
      });
      if (this.chkName === "duo") {
        this.checkedIds = [];
        this.allCheck = true;
      } else if (this.chkName === "dan") {
        this.allCheck = false;
        ids.forEach((id) => {
          const index = this.checkedIds.indexOf(id);
          if (index === -1) {
            this.checkedIds.push(id);
          }
        });
      } else {
        ids.forEach((id) => {
          const index = this.checkedIds.indexOf(id);
          if (index > -1) {
            this.checkedIds.splice(index, 1);
          }
        });
      }
    },
    // 分开选择
    changeOne(v, recovery) {
      if (v) {
        if (this.chkName === "duo") {
          const index = this.noChecked.indexOf(recovery.recovery_order_id);
          if (index > -1) this.noChecked.splice(index, 1);
        } else {
          const index = this.checkedIds.indexOf(recovery.recovery_order_id);
          if (index === -1) this.checkedIds.push(recovery.recovery_order_id);
        }
      } else {
        if (this.chkName === "duo") {
          const index = this.noChecked.indexOf(recovery.recovery_order_id);
          if (index === -1) this.noChecked.push(recovery.recovery_order_id);
        } else {
          const index = this.checkedIds.indexOf(recovery.recovery_order_id);
          if (index > -1) this.checkedIds.splice(index, 1);
        }
      }
      console.log("分开选择", this.checkedIds);
    },
    batchGroup() {
      if (this.checkedIds.length === 0)
        return this.$message.warning("请先选择用户");
      this.recoveryOrderIdList.recovery_order_id_list = this.checkedIds;
      recoveryOrderBatchSettApi(this.recoveryOrderIdList)
        .then((res) => {
          this.$message.success(res.message);
          this.dialogVisibleStatus = false;
          this.checkedIds = [];
          this.getList("");
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
    },

    recoveryMenuCategory() {
      recoveryCategoryMenuListApi(2)
        .then((res) => {
          console.log(res.data);
          this.recoveryCateList = res.data;
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
    },
    headerList() {
      recoveryOrderChartListApi({ uid: 7598 })
        .then((res) => {
          this.orderChartType = res.data;
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
    },
    // 选择时间
    selectChange(tab) {
      this.tableFrom.date = tab;
      this.tableFrom.page = 1;
      this.timeVal = [];
      this.getList(1);
    },
    // 具体日期
    onchangeTime(e) {
      this.timeVal = e;
      this.tableFrom.date = e ? this.timeVal.join("-") : "";
      this.tableFrom.page = 1;
      this.getList(1);
    },

    // 选择时间
    selectWarehousChange(tab) {
      this.tableFrom.warehous_date = tab;
      this.tableFrom.page = 1;
      this.warehousTimeVal = [];
      this.getList(1);
    },
    // 具体日期
    onchangeWarehousTime(e) {
      this.warehousTimeVal = e;
      this.tableFrom.warehous_date = e ? this.warehousTimeVal.join("/") : "";
      this.tableFrom.page = 1;
      this.getList(1);
    },
    // 列表
    getList(num) {
      this.listLoading = true;
      this.tableFrom.page = num ? num : this.tableFrom.page;
      this.tableFrom.appraisal_type_list = 1;
      this.tableFrom.uid = 7598;
      recoveryOrderListApi(this.tableFrom)
        .then((res) => {
          this.tableData.data = res.data.list;
          this.tableData.total = res.data.count;
          this.getCardList();
          this.checkedIds = [];
          this.listLoading = false;
        })
        .catch((res) => {
          this.listLoading = false;
          this.$message.error(res.message);
        });
    },
    pageChange(page) {
      this.tableFrom.page = page;
      this.getList("");
    },
    handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList("");
    },
    getCardList() {
      recoveryOrderCardListApi(this.tableFrom)
        .then((res) => {
          this.cardLists = res.data;
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
    },
    // 详情
    onDetail(id) {
      this.appraisal_order_id = id;
      this.dialogVisible = true;
      this.isExamine = false;
      recoveryOrderDetailApi(id)
        .then((res) => {
          this.formData = res.data;
        })
        .catch(({ message }) => {
          this.$message.error(message);
        });
    },
  },
};
</script>

<style scoped lang="scss">
.boxDetial .el-form-item {
  margin-bottom: 0px;
}

.box-container {
  overflow: hidden;
}

.box-container .list {
  float: left;
  line-height: 40px;
}

.box-container .sp {
  width: 50%;
}

.box-container .sp3 {
  width: 33.3333%;
}

.box-container .sp100 {
  width: 100%;
}

.box-container .list .name {
  display: inline-block;
  width: 150px;
  text-align: right;
  color: #606266;
}

.box-container .list.image {
  margin-bottom: 40px;
}

.box-container .list.image img {
  position: relative;
  top: 40px;
}

/deep/ .el-form-item__content .el-rate {
  position: relative;
  top: 8px;
}

.sku-tb {
  border: 1px solid black;
  border-collapse: collapse;
  margin-bottom: 20px;
  width: 100%;
  tr {
    th,
    td {
      border: 1px solid black;
      text-align: center;

      .sku-name {
        margin: 0 auto;
        width: 100px;
        /*height: 30px;*/
        /*overflow: hidden;*/
        line-height: 24px;
        text-overflow: ellipsis;
        /*word-break: keep-all;*/
      }
    }
  }
}

.skuList {
  border-bottom: 2px solid #f4f4f5;
  margin-bottom: 10px;
}
.blodClass {
  font-size: 14px;
  color: red;
  font-weight: bold;
}
</style>
